//主页面
// const index = r => require.ensure([], () => r(require('@/components/home.vue')), 'index');
const index = () => import(/* webpackChunkName:'grounp' */ '@/components/home.vue');

//期现账户信息查询
const futureCurrentInfoList = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/futuresStrategy/futureCurrentInfo/list.vue');

//套利策略查询
const straddleList = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/futuresStrategy/straddle/list.vue');

//基差策略查询
const basisList = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/futuresStrategy/basis/list.vue');

//单边策略查询
const singleList = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/futuresStrategy/single/list.vue');

const futuresStrategyRouter = {
  path: '/futuresStrategy',
  component: index,
  children: [
    {
      path: 'futureCurrentInfoList',
      name: 'futureCurrentInfoList',
      component: futureCurrentInfoList,
      meta: {
        keepAlive: true,
        title: '期现账户信息查询',
      },
    },
    {
      path: 'straddleList',
      name: 'straddleList',
      component: straddleList,
      meta: {
        keepAlive: true,
        title: '套利策略查询',
      },
    },
    {
      path: 'basisList',
      name: 'basisList',
      component: basisList,
      meta: {
        keepAlive: true,
        title: '基差策略查询',
      },
    },
    {
      path: 'singleList',
      name: 'singleList',
      component: singleList,
      meta: {
        keepAlive: true,
        title: '单边策略查询',
      },
    },
  ],
};
export default futuresStrategyRouter;
